<script>
import { mapGetters } from "vuex";
import { Line , mixins} from "vue-chartjs";

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  data() {
    return {
      gradient: null,
      gradient2: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.renderChart(this.chartData, this.options)
      this.$root.$emit("hideLoading");
      /* 
      console.log(this.data)
      this.renderChart(
        {
          labels: this.labels,
          datasets: this.data
        },
        {
          responsive: true,
          maintainAspectRatios: false,
          scales: {
            yAxes: this.yAxes,
            xAxes: this.xAxes
          },
          tooltips: {
            mode: "index",
            fontFamily: "Roboto",
            callbacks: {
              title: function(tooltipItem, data) {
                return (
                  el.xAxes[0].scaleLabel.labelString +
                  " : " +
                  data.labels[tooltipItem[0].index]
                );
              },

              label: function(tooltipItem, data) {
                return (
                  data.datasets[tooltipItem.datasetIndex].label +
                  ":" +
                  tooltipItem.yLabel.toLocaleString()
                );
              }
            }
          },
          annotation: this.annotation 
        }
      ); */
    });
  },
  methods: {
    setFormatNumber(num, simbol) {
      let separador = "."; // separador para los miles
      let sepDecimal = ","; // separador para los decimales
      num += "";
      var splitStr = num.split(".");
      var splitLeft = splitStr[0];
      var splitRight = splitStr.length > 1 ? sepDecimal + splitStr[1] : "";
      var regx = /(\d+)(\d{3})/;
      while (regx.test(splitLeft)) {
        splitLeft = splitLeft.replace(regx, "$1" + separador + "$2");
      }
      return simbol + splitLeft + splitRight;
    },
    setFormatTable(table, restricts) {
      let cont = 0;
      table.forEach(element => {
        for (var property in element) {
          if (property != " " && typeof restricts[property] == "undefined") {
            let str = element[property];
            str = str.replace(",", ".");
            str = this.setFormatNumber(str, "");
            table[cont][property] = str;
          }
        }
        cont++;
      });
    },
    setCharAt(str, index, chr) {
      if (index > str.length - 1) return str;
      return str.substr(0, index) + chr + str.substr(index + 1);
    },
    formatHeadersChips(headers) {
      let cont = 0;
      headers.forEach(element => {
        for (var property in element) {
          if (property != "") {
            let str = element[property];
            str = str.replace(",", ".");
            str = this.setFormatNumber(str, "");
            this.headerChips[cont][property] = str;
          }
        }
        cont++;
      });
    }
  }
};
</script>